import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-arrow_jax_62543a7614caacd63954ddfbac2917a3",
  "use": "ico-arrow_jax_62543a7614caacd63954ddfbac2917a3-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ico-arrow_jax_62543a7614caacd63954ddfbac2917a3\">\n<path d=\"M20.25 12.2871L12.2872 4.32436L4.3245 12.2871\" stroke=\"white\" stroke-width=\"2.4\" />\n<path opacity=\"0.4\" d=\"M20.25 20.7871L12.2872 12.8244L4.3245 20.7871\" stroke=\"white\" stroke-width=\"2.4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol